import { ManagementAppProxyRequestSchema, getManagementAppRouteDefinition, } from '@trinity/custom-page-proxy-routes';
export class ChatAPIProxyClient {
    constructor(authenticatedClient) {
        this.authenticatedClient = authenticatedClient;
    }
    async invokeManagementAppRoute(routeLabel, payload, query) {
        const route = getManagementAppRouteDefinition(routeLabel);
        route.requestSchema.parse(payload);
        const requestBody = ManagementAppProxyRequestSchema.parse({
            route: routeLabel,
            payload,
            query,
        });
        const response = await this.authenticatedClient.post('/proxy/custom-pages/management-app', requestBody);
        return route.responseSchema.parse(response.data);
    }
}
